<span class="switch" [class.switch--checked]="valueState()" [class.switch--disabled]="disabledState()" [attr.aria-hidden]="presentation() ? true : null">
  @if (!presentation()) {
    <input type="checkbox" role="switch" [attr.aria-label]="ariaLabel()" [checked]="valueState()" [disabled]="disabledState()" (change)="clicked()" />
  }
  <span class="switch__track" aria-hidden="true"></span>
</span>
